<div ngModelGroup="invoicingTermsDTO">
  <div class="d-flex flex-column gap-3">
    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityInvoicingTermsDTO.invoiceSeriesPrefix"
                   class="w-100"
                   formInlineError
                   id="nvoiceSeriesPrefix"
                   name="invoiceSeriesPrefix"
                   pInputText
                   required
                   type="text" data-testid="nvoice-series-prefix-input">
            <label for="invoiceSeriesPrefix">{{'platform-administration.company.legal-entity.inputs.invoicingTerms.invoiceSeriesPrefix' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <p-inputNumber
                   [(ngModel)]="platformLegalEntityInvoicingTermsDTO.paymentTimeLimit"
                   [maxFractionDigits]="0"
                   class="w-100 w-100"
                   formInlineError
                   id="paymentTimeLimit"
                   inputStyleClass="w-100"
                   name="paymentTimeLimit"
                   required
                   data-testid="payment-time-limit-input">
            </p-inputNumber>
            <label for="paymentTimeLimit">{{'platform-administration.company.legal-entity.inputs.invoicingTerms.paymentTimeLimit' | translate}} *</label>
          </p-floatlabel>
    </div>
  </div>
</div>


